import { MARQUEE_ITEMS } from "@/constants/site";
import { useLang } from "@/lib/lang";

export default function Marquee() {
  const { lang } = useLang();
  const row = MARQUEE_ITEMS.map((it, i) => (
    <span key={i} className="inline-flex items-center gap-8 pr-8">
      <span className={`${lang === "en" ? "font-display" : "font-bengali"} text-2xl sm:text-4xl font-bold text-transparent`} style={{ WebkitTextStroke: "1px rgba(242,177,52,0.55)" }}>
        {lang === "en" ? it.en : it.bn}
      </span>
      <svg width="14" height="14" viewBox="0 0 14 14" className="text-[#D7261E] shrink-0" aria-hidden="true">
        <rect x="3" y="3" width="8" height="8" transform="rotate(45 7 7)" fill="currentColor" />
      </svg>
    </span>
  ));

  return (
    <div className="relative py-8 sm:py-12 border-y border-[#F2B134]/15 overflow-hidden bg-[#1E0A0E]/40" aria-hidden="true">
      <div className="marquee-track flex w-max whitespace-nowrap">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
}
